import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from "./App";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import './index.css';
import { AwsRumProvider } from 'aws-rum-react';
import aws_config from './modified_aws-export';
import ImageVectorizationPage from "./pages/ImageVectorization/ImageVectorizationPage";
import MatchedPairsPage from './pages/MatchedPairs/MatchedPairsPage';
import ManualFinderPage from "./pages/ManualFinder/ManualFinderPage";
import { ErrorPage } from './pages/ErrorPage';
import { Config } from "./pages/ConfigPage";
import ImageMatcherPage from "./pages/ImageMatcher/ImageMatcherPage";
import ImageMatcherUploadedPage from "./pages/ImageMatcher/ImageMatcherUploadedPage";
import { imageMatcherResultPageLoader } from "./services/imageMatcher/getDropZoneResult";
import ImageMatcherResultPage from "./pages/ImageMatcher/ImageMatcherResultPage";
import ImageMatcherUploadPage from "./pages/ImageMatcher/ImageMatcherUploadPage";
import { ProtectedRoute } from "./components/ProtectedRoute/ProtectedRoute";
import ImageGenerationResultPage from './pages/ImageGeneration/ImageGenerationResultPage';


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/image-matcher" replace />
      },
      {
        path: "image-matcher",
        element: <ImageMatcherPage />,
        children: [
          {
            path: "",
            element: <ImageMatcherUploadPage />
          },
          {
            path: "upload",
            element: <ImageMatcherUploadPage />
          },
          {
            path: "uploaded",
            element: <ImageMatcherUploadedPage />
          },
          {
            path: "uploaded/result/:uuid",
            element: <ImageMatcherResultPage />,
            loader: imageMatcherResultPageLoader,
          },
        ],
      },
      {
        path: "config",
        element: <Config />,
      },
      {
        path: "special-tools-finder",
        element: <ManualFinderPage />,
      },
      {
        path: "matched-pairs",
        element: <MatchedPairsPage />,
      },
      {
        path: "vectorization",
        element: <ProtectedRoute><ImageVectorizationPage /></ProtectedRoute>
      },
      {
        path: "image-generation",
        element: <ProtectedRoute permissionType="imageGeneration"><ImageGenerationResultPage /></ProtectedRoute>
      }
    ]
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <AwsRumProvider
    allowCookies
    endpoint="https://dataplane.rum.eu-central-1.amazonaws.com"
    id={aws_config.RumUserMonitoring.RumMonitorId}
    identityPoolId={aws_config.aws_cognito_identity_pool_id}
    region="eu-central-1"
    sessionSampleRate={1}
    telemetries={aws_config.RumUserMonitoring.RumTelemetries.split(",")}
    version="1.0.0"
    sessionAttributes={{ "screenResolution": window.screen.availWidth + " x " + window.screen.availHeight }}
  >
    <RouterProvider router={router} />
  </AwsRumProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
